import React, { memo } from 'react';
import ServiceLogo from '../../common/logo/ServiceLogo';
import PillButton from '../../common/button/PillButton';
import { Plus } from 'lucide-react';

import styles from './styles/ServiceDetails.module.css';

const ServiceHeader = ({ service, isAdded, handleAdd }) => {
    return (
        <div className={styles.header}>
            <div className={styles.logoSection}>
                <ServiceLogo
                    logo={service.logo}
                    name={service.name}
                    size="xlarge"
                />
            </div>

            <div className={styles.mainInfo}>
                <div>
                    <h2 className={styles.title}>{service.name}</h2>
                    <p className={styles.description}>{service.description}</p>
                </div>
                <div className={styles.actions}>
                    {!isAdded && (
                        <PillButton onClick={handleAdd} size="small">
                            <Plus size={'.875rem'} />
                            Add Service
                        </PillButton>
                    )}
                </div>
            </div>
        </div>
    );
};

export default memo(ServiceHeader);
